<div class="center">
    <p *ngIf="!isLinked">{{ ('Click the button below and follow the instructions to link {}' | translate).replace('{}', 'WineSuite Payments') }}</p>
    <p *ngIf="isLinked">{{ 'Manage your WineSuite Payments configuration and settings' | translate }}</p>
    <div style="display: flex; gap: 10px; justify-content: center;">
        <button
                *ngIf="!isLinked"
                (click)="clickHandler('connect')"
                mat-stroked-button
        >
            {{ "Link WineSuite Payments" | translate }}
        </button>
        <button
                *ngIf="isLinked"
                (click)="clickHandler('modify')"
                mat-stroked-button
        >
            {{ "Modify Config" | translate }}
        </button>
        <button
                *ngIf="isLinked"
                (click)="clickHandler('remove')"
                mat-stroked-button
                style="color: red;"
        >
            {{ "Remove" | translate }}
        </button>
    </div>
</div>

